export default __webpack_public_path__ + "static/media/coinbase-wallet.9fa41556.svg";